
    const data = {"name":"src/core/icons/arrow-u-left-bottom","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M20 10.5a6.5 6.5 0 0 1-6.5 6.5H7.83l3.09 3.09L9.5 21.5 4 16l5.5-5.5 1.41 1.41L7.83 15h5.67c2.5 0 4.5-2 4.5-4.5S16 6 13.5 6H6V4h7.5a6.5 6.5 0 0 1 6.5 6.5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            